<div class="glap-dashboard-bg position-relative">


<div class="glap-breadcrumb mb-5">
  <div class="row">
    <div class="col-lg-6 col-sm-12">
      <h1 class="welcome-title">Welcome {{profileInfo?.fullName}}!</h1>
    </div>
    <div class="col-lg-6 col-sm-12">
      <h1 class="dashboard-title float-end">Leaf Management System</h1>
    </div>
  </div>
</div>


<div class="row">

  <div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3" *ngFor="let item of menuCategory">
    <div class="card d-flex flex-column position-relative mb-4 text-right card-purchase-open">
        <div class="card-body">
            <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">

                <div class="pr-2 pr-md-4">
                    <h2>{{ item?.featureCategoryName }}</h2>
                </div>
                <i class="icon icon-buy-crypto"></i>
            </div>
        </div>
    </div>
</div>

<!-- <div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3">
    <div class="card d-flex flex-column position-relative mb-4 text-right card-buying">
        <div class="card-body">
            <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">
                <div class="pr-2 pr-md-4">
                    <h2>Add Tobacco Type</h2>
                </div>
                <i class="icon icon-buy-crypto"></i>
            </div>
        </div>
    </div>
</div>

<div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3">
    <div class="card d-flex flex-column position-relative mb-4 text-right card-purchase-sweeping-bale">
        <div class="card-body">
            <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">
                <div class="pr-2 pr-md-4">
                    <h2>Assign Role</h2>
                </div>
                <i class="icon icon-broom"></i>
            </div>
        </div>
    </div>
</div>

<div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3">
    <div class="card d-flex flex-column position-relative mb-4 text-right card-purchase-close">
        <div class="card-body">
            <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">
                <div class="pr-2 pr-md-4">
                    <h2>Data Upload</h2>
                </div>
                <i class="icon icon-clipboard-close"></i>
            </div>
        </div>
    </div>
</div>

<div class="col-12 col-lg-6 col-md-6 col-sm-6 col-xl-6 col-xxl-3">
    <div class="card d-flex flex-column position-relative mb-4 text-right card-dispatch">
        <div class="card-body">
            <div class="align-content-center align-items-center d-flex flex-wrap justify-content-between">
                <div class="pr-2 pr-md-4">
                    <h2>User Controls</h2>
                </div>
                <i class="icon icon-clipboard-close"></i>
            </div>
        </div>
    </div>
</div> -->

</div>

</div>
